import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MaterialCatalogListComponent } from './material-catalog-list.component';
import { ColumnSelectionModule } from '../../columns/column-selection/column-selection.module';
import { FilterSelectionModule } from '../../filter/filter-selection/filter-selection.module';
import { MatRowKeyboardSelectionModule } from '../../../core/directive/mat-row-keyboard-selection.module';
import { MaterialCatalogListTableModule } from './material-catalog-list-table/material-catalog-list-table.module';
import { MaterialCatalogListItemModule } from './material-catalog-list-item/material-catalog-list-item.module';
import { ToggleMenuButtonModule } from '../../toggle-menu-button/toggle-menu-button.module';

@NgModule({
  declarations: [MaterialCatalogListComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    MatTableModule,
    ColumnSelectionModule,
    FilterSelectionModule,
    MatRowKeyboardSelectionModule,
    MaterialCatalogListTableModule,
    MaterialCatalogListItemModule,
    ToggleMenuButtonModule,
  ],
  exports: [MaterialCatalogListComponent],
  providers: [],
})
export class MaterialCatalogListModule {}
